class Auth0Error extends Error {
  constructor(message) {
    super(message);
    this.name = 'Auth0Error';
  }
}

export default Auth0Error;
